import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { movieCategories } from "@/mocks/categories";

export default function SiteHeader() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [showCategories, setShowCategories] = useState(false);
  const [showMobile, setShowMobile] = useState(false);

  const handleSearch = (event: FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setShowMobile(false);
  };

  const navLink =
    "text-sm text-foreground-200 transition hover:text-accent-400";

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/70 bg-background-100/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2" aria-label="电影天堂首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-950">
            <i className="ri-movie-2-line text-xl" />
          </span>
          <span className="font-display text-xl tracking-wide text-foreground-50 md:text-2xl">
            电影天堂
          </span>
        </Link>

        <nav className="hidden items-center gap-6 lg:flex">
          <Link to="/" className={navLink}>
            首页
          </Link>
          <div
            className="relative"
            onMouseEnter={() => setShowCategories(true)}
            onMouseLeave={() => setShowCategories(false)}
          >
            <button
              type="button"
              className={`${navLink} flex items-center gap-1 whitespace-nowrap`}
              onClick={() => setShowCategories((prev) => !prev)}
            >
              电影分类
              <i className="ri-arrow-down-s-line" />
            </button>
            {showCategories && (
              <div className="absolute left-0 top-full z-50 w-[420px] pt-3">
                <div className="grid grid-cols-3 gap-1 rounded-lg border border-background-200/70 bg-background-100 p-3">
                  {movieCategories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-200 transition hover:bg-background-200 hover:text-accent-400"
                    >
                      <i className={`${cat.icon} text-accent-500`} />
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
          <Link to="/news" className={navLink}>
            电影资讯
          </Link>
          <Link to="/about" className={navLink}>
            关于我们
          </Link>
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden w-64 items-center md:flex lg:w-72">
          <div className="flex w-full items-center rounded-md border border-background-300/70 bg-background-50 px-3 py-1.5 focus-within:border-accent-500/70">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              type="search"
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影、导演、演员…"
              className="ml-2 w-full bg-transparent text-sm text-foreground-50 placeholder:text-foreground-500 focus:outline-none"
            />
          </div>
        </form>

        <button
          type="button"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300/70 text-foreground-100 md:ml-0 lg:hidden"
          onClick={() => setShowMobile((prev) => !prev)}
          aria-label="打开菜单"
        >
          <i className={showMobile ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </div>

      {showMobile && (
        <div className="border-t border-background-200/70 bg-background-100 px-4 pb-5 pt-4 lg:hidden">
          <form onSubmit={handleSearch} className="mb-4 flex items-center rounded-md border border-background-300/70 bg-background-50 px-3 py-2 md:hidden">
            <i className="ri-search-line text-sm text-foreground-400" />
            <input
              type="search"
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索电影…"
              className="ml-2 w-full bg-transparent text-sm text-foreground-50 placeholder:text-foreground-500 focus:outline-none"
            />
          </form>
          <div className="flex flex-col gap-1">
            <Link to="/" className="rounded-md px-3 py-2 text-sm text-foreground-100 hover:bg-background-200" onClick={() => setShowMobile(false)}>
              首页
            </Link>
            <p className="px-3 pt-2 text-xs text-foreground-500">电影分类</p>
            <div className="grid grid-cols-2 gap-1">
              {movieCategories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-200 hover:bg-background-200 hover:text-accent-400"
                  onClick={() => setShowMobile(false)}
                >
                  <i className={`${cat.icon} text-accent-500`} />
                  {cat.name}
                </Link>
              ))}
            </div>
            <Link to="/news" className="rounded-md px-3 py-2 text-sm text-foreground-100 hover:bg-background-200" onClick={() => setShowMobile(false)}>
              电影资讯
            </Link>
            <Link to="/about" className="rounded-md px-3 py-2 text-sm text-foreground-100 hover:bg-background-200" onClick={() => setShowMobile(false)}>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}